// @flow
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _isEqual from 'lodash/isEqual';

import DiamondDatagridHeader from '@components/datagrids/headers/DiamondDatagridHeader';

type TProps = {
  dyor: boolean,
  headerResponsiveColumns: Object
};

function Headers ({ dyor, headerResponsiveColumns }: TProps) {
  const dispatch = useDispatch();
  const sortedColumn = useSelector((state) => state.diamondSearch.sortBy);
  const sortDirection = useSelector((state) => state.diamondSearch.sortDir);
  const onHeaderItemClick = (headerKey) => {
    dispatch({
      type: 'DIAMOND_HEADER_ITEM_SELECT',
      item: headerKey,
      looseDiamonds: !dyor
    });
  };

  return (
    <DiamondDatagridHeader
      onItemClick={onHeaderItemClick}
      sortedColumn={sortedColumn}
      sortDirection={sortDirection}
      tableMinimumWidth={headerResponsiveColumns.tableMinimumWidth}
      responsiveColumnClasses={headerResponsiveColumns.classes}
      allowCompare
    />
  );
}

export default memo(Headers, _isEqual);
